<template>
  <div class="container mt-lg-5 mb-5 texto-principal">
    <div class="d-flex flex-row">
      <div class="d-flex flex-row align-items-center justify-content-center gap-2">
        <router-link to="/personas" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('volver') }}</span>
        </router-link>
        <h2 class="m-0">{{ $t('grupo') }}</h2>
      </div>
    </div>
    <div>
      <form @submit.prevent="saveChanges" class="d-flex flex-column gap-2">
        <p class="m-0 fs-7 w-100"><strong>{{ $t('nombreGrupo') }}:</strong> <input type="text" v-model="grupo.Nombre" class="form-control sombra-sm" maxlength="100" required /></p>

        <!-- Listas -->
        <div class="d-flex flex-column w-100 gap-2">
          <!-- Mostrar listas actuales -->
          <p class="fs-7 m-0"><strong>{{ $t('listas') }}:</strong></p>
          
          <div v-for="(lista, index) in grupo.Listas" :key="lista.IdLista" class="d-flex flex-column w-100 border borde-secundario fondo-secundario rounded sombra-sm">
            <!-- Mostrar el nombre del evaluador o 'submit' si no existe -->
            <div class="d-flex flex-row gap-2 w-100 ps-2 pe-3 border border-0 fondo-secundario rounded justify-content-between align-items-center sombra-sm" style="min-height: 50px; cursor: pointer;" @click="lista.showValues = !lista.showValues">
              <div class="d-flex flex-row gap-2 align-items-center">
                  <input type="text" v-model="lista.Nombre" :placeholder="$t('nombreLista')" class="form-control sombra-sm" maxlength="50" required/>
                  <div class="d-flex flex-row gap-2 align-items-center position-relative w-100" @click.stop>
                    <input type="text" v-model="lista.SearchQuery" :placeholder="$t('buscarPersona') + '...'" class="form-control sombra-sm w-100" @input="filterPersonas(lista)" />
                    <ul v-if="lista.FilteredPersonas.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%;">
                      <li v-for="evaluado in lista.FilteredPersonas" :key="evaluado?.IdPersona" class="list-group-item list-group-item-action text-start fondo-terciario texto-principal borde-secundario" @click="selectPersona(evaluado, lista)" style="cursor: pointer;">
                        {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                      </li>
                    </ul>
                  </div>
                  <button type="button" @click="removeGrupo(index)" class="btn btn-danger btn-sm ms-2 sombra-sm">{{ $t('eliminar') }}</button>
              </div>

              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: lista.showValues ? 'scaleY(1)' : 'scaleY(-1)' }">
                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
              </svg>
            </div>


            <!-- Mostrar los valores solo si showValues es true -->
            <div v-if="lista.showValues">
              <!-- Mostrar los valores agrupados -->
              <div v-if="lista.PersonasRelacionadas" class="d-flex flex-column p-2 px-3">
                <span class="fs-7 m-0"><strong>{{$t('personasRelacionadas')}}:</strong></span>
                <div v-for="(persRel) in lista.PersonasRelacionadas" :key="persRel.IdPersona" class="d-flex flex-row justify-content-between w-100">
                  <span class="fs-7 m-0 ms-2">-{{ (persRel.Persona?.Apellido + " " + persRel.Persona?.Nombre) }}</span>
                </div>
                <button v-if="!addPersonaRelacionada" type="button" class="btn btn-primary mt-2 sombra-sm" @click="addPersonaRelacionada = true">{{ $t('agregarPersona') }}</button>
                <div v-if="addPersonaRelacionada" class="d-flex flex-row gap-2 align-items-center position-relative" @click.stop>
                  <input type="text" v-model="lista.SearchQueryRelacionada" :placeholder="$t('buscarPersona') + '...'" class="form-control sombra-sm w-100" @input="filterPersonasRelacionada(lista)" />
                  <ul v-if="lista.FilteredPersonasRelacionada.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%;">
                    <li v-for="evaluado in lista.FilteredPersonasRelacionada" :key="evaluado?.IdPersona" class="list-group-item list-group-item-action text-start fondo-terciario texto-principal borde-secundario" @click="selectPersonaRelacionada(evaluado, lista)" style="cursor: pointer;">
                      {{ evaluado.Apellido + ' ' + evaluado.Nombre }}
                    </li>
                  </ul>
                  <button type="button" class="btn btn-primary fs-6 sombra-sm" @click="agregarPersonaRelacionada(lista)">
                    {{ $t('agregar') }}
                  </button>
                  <button type="button" class="btn btn-secondary fs-6 sombra-sm" @click="addPersonaRelacionada = false">
                    {{ $t('cancelar') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-primary mt-2" @click="addLista">{{ $t('agregarLista') }}</button>
        </div>
        <div class="d-flex flex-row gap-2">
          <button class="btn btn-success mt-3" type="submit">{{ $t('guardar') }}</button>
          <router-link class="btn btn-secondary mt-3" to="/verGrupo">{{ $t('cancelar') }}</router-link>
          <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted } from 'vue';
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'EditarRoles',
  setup() {
    const { t } = useI18n();
    var loading = ref(false);
    var addPersonaRelacionada = ref(false);
    //var loadingPermiso = ref(false);
    const router = useRouter();
    //const user = computed(() => store.state.user);
    const grupo = ref({});
    const allPersonas = ref({});
    var selectedPermiso = ref({});
    const empleados = ref([]);

    const fetchPersonas = async () => {
      try {
        const response2 = await api.get(`api/Persona/ByRole?role=Empleado`);
        empleados.value = response2.data;
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonas = (lista) => {
      if (!lista.SearchQuery) {
        lista.FilteredPersonas = [];
      } else {
        const query = lista.SearchQuery.toLowerCase();
        lista.FilteredPersonas = empleados.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };

    const selectPersona = (evaluado, lista) => {
      lista.PersonaResponsable = evaluado; // Asigna la persona seleccionada
      lista.IdResponsable = evaluado.IdPersona
      lista.SearchQuery = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      lista.FilteredPersonas = []; // Limpia la lista filtrada
    };

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonasRelacionada = (lista) => {
      if (!lista.SearchQueryRelacionada) {
        lista.FilteredPersonasRelacionada = [];
      } else {
        const query = lista.SearchQueryRelacionada.toLowerCase();
        lista.FilteredPersonasRelacionada = empleados.value.filter(evaluado =>
          `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase().includes(query)
        ).slice(0, 10);
      }
    };

    const selectPersonaRelacionada = (evaluado, lista) => {
      lista.SearchQueryRelacionada = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      lista.FilteredPersonasRelacionada = []; // Limpia la lista filtrada
    };

    const agregarPersonaRelacionada = (lista) => {
      const persona1 = empleados.value.find(
        (p) => `${p.Apellido} ${p.Nombre}` === lista.SearchQueryRelacionada
      );
      if (!persona1) {
        alert("No se encontro a la persona")
        return; // Si no hay persona, salir
      }

      // Verificar que no esté ya en los autorizadores
      const yaExiste = lista.PersonasRelacionadas.some(a => a.IdPersona === persona1.IdPersona);
      if (!yaExiste) {
        if (lista.PersonaResponsable.IdPersona == persona1.IdPersona) {
          alert("La persona no se puede agregar porque ya es responsable de la lista.")
        }else{
          lista.PersonasRelacionadas.push({
            IdLista: lista.IdLista || '00000000-0000-0000-0000-000000000000',
            IdPersona: persona1.IdPersona,
            Persona: persona1,
          });
        }
      }else{
        alert("La persona ya esta")
      }

      lista.SearchQueryRelacionada = ''
      lista.FilteredPersonasRelacionada = []
    };

    const addLista = () => {
      grupo.value.Listas.push({
        IdLista: '00000000-0000-0000-0000-000000000000',
        IdGrupo: grupo.value.IdGrupo,
        Nombre: '',
        PersonaResponsable: {},
        PersonasRelacionadas: [],
        SearchQuery: '',
        FilteredPersonas: [],
        SearchQueryRelacionada: '',
        FilteredPersonasRelacionada: [],
      });
    }

    const saveChanges = async () => {
      try {
        loading.value = true;
        console.log(grupo.value)

        const payloadLimpio = createGrupoPayload(grupo.value);
        console.log(payloadLimpio)

        await api.post(`api/Grupos`, payloadLimpio);
        loading.value = false;
        await router.push('/personas/verGrupos');
      } catch (error) {
        loading.value = false;
        console.error('Error al guardar los cambios:', error);
        alert('Hubo un problema al guardar los datos.');
      }
    };

    function createGrupoPayload(grupoFromState) {
      // 1. Mapea el objeto principal (GrupoDTO)
      const payload = {
        IdGrupo: grupoFromState.IdGrupo,
        Nombre: grupoFromState.Nombre,
        // 2. Mapea la colección de Listas usando .map()
        Listas: grupoFromState.Listas.map(lista => {
          
          // 3. Dentro de cada opción, mapea la sub-colección de PersonasRelacionadas
          const personasRelacionadasPayload = lista.PersonasRelacionadas.map(persona => {
            // Solo nos interesa el IdPersona para la relación
            return {
              IdPersona: persona.IdPersona
            };
          });

          // 4. Construye el objeto ListaDTO limpio
          return {
            IdLista: lista.IdLista,
            IdGrupo: lista.IdGrupo,
            Nombre: lista.Nombre,
            // LÓGICA CLAVE: Si IdResponsable es un string vacío, o undefined, manda null.
            IdResponsable: lista.IdResponsable || null, 
            PersonasRelacionadas: personasRelacionadasPayload
          };
        })
      };

      return payload;
    }

    const removeGrupo = (index) => {
      // Eliminar la nacionalidad en el índice dado
      grupo.value.Listas.splice(index, 1);
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      grupo.value = {
          IdGrupo: '00000000-0000-0000-0000-000000000000',
          Nombre:'',
          Listas: []
      }
      fetchPersonas();
    });

    return {
      t,
      grupo,
      loading,
      saveChanges,
      allPersonas,
      selectedPermiso,
      removeGrupo,
      addLista,
      selectPersona,
      filterPersonas,
      selectPersonaRelacionada,
      filterPersonasRelacionada,
      addPersonaRelacionada,
      agregarPersonaRelacionada
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
</style>
